export default "__VITE_ASSET__5abbf2f6__"